

















































import { Component, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import menu_optionModule from "@/store/modules/menu_option-module";
import { MenuItem } from "@/components/Menu/menu-item";
import MenuTreeItem from "./MenuTreeItem.vue";

interface MenuTreeNode {
  id: number;
  icon: string;
  icon_fntaws: string;
  text: string;
  color: string;
  link: string;
  permission: string;
  id_padre: number;
  url_fija: boolean;
  orden: number;
  children?: MenuTreeNode[];
}

@Component({
  components: { draggable, MenuTreeItem },
})
export default class MenuOrganizador extends Vue {
  public menuTree: MenuTreeNode[] = [];
  public guardando: boolean = false;

  public dragOptions = {
    animation: 200,
    group: "menu",
    disabled: false,
    ghostClass: "ghost",
    handle: ".drag-handle",
  };

  async created() {
    await this.cargarMenu();
  }

  async cargarMenu() {
    await menu_optionModule.getmenu_options();
    this.menuTree = this.buildTree(menu_optionModule.menu_options);
  }

  /**
   * Construye el árbol jerárquico de menús
   */
  buildTree(items: MenuItem[]): MenuTreeNode[] {
    const map = new Map<number, MenuTreeNode>();
    const roots: MenuTreeNode[] = [];

    // Crear mapa de todos los items
    items.forEach((item) => {
      map.set(item.id, {
        id: item.id,
        icon: item.icon,
        icon_fntaws: item.icon_fntaws,
        text: item.text,
        color: item.color,
        link: item.link,
        permission: item.permission,
        id_padre: item.id_padre,
        url_fija: item.url_fija,
        orden: item.orden,
        children: [],
      });
    });

    // Construir jerarquía
    items.forEach((item) => {
      const node = map.get(item.id)!;
      if (!item.id_padre || item.id_padre === 0) {
        roots.push(node);
      } else {
        const parent = map.get(item.id_padre);
        if (parent && parent.children) {
          parent.children.push(node);
        }
      }
    });

    // Ordenar por campo orden
    const sortByOrden = (nodes: MenuTreeNode[]) => {
      nodes.sort((a, b) => (a.orden || 0) - (b.orden || 0));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByOrden(node.children);
        }
      });
    };

    sortByOrden(roots);
    return roots;
  }

  /**
   * Handler para cuando termina el drag
   */
  onDragEnd() {
    this.recalcularOrdenes(this.menuTree, null);
  }

  /**
   * Recalcula los números de orden basándose en la nueva posición
   */
  recalcularOrdenes(
    nodes: MenuTreeNode[],
    parentId: number | null,
    startOrder: number = 1
  ) {
    nodes.forEach((node, index) => {
      node.orden = startOrder + index;
      node.id_padre = parentId || 0;

      if (node.children && node.children.length > 0) {
        this.recalcularOrdenes(node.children, node.id, 1);
      }
    });
  }

  /**
   * Actualiza un item del menú (desde el child component)
   */
  updateMenuItem(updatedNode: MenuTreeNode) {
    this.updateNodeInTree(this.menuTree, updatedNode);
    this.recalcularOrdenes(this.menuTree, null);
  }

  /**
   * Actualiza un nodo en el árbol recursivamente
   */
  updateNodeInTree(nodes: MenuTreeNode[], updatedNode: MenuTreeNode): boolean {
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].id === updatedNode.id) {
        nodes[i] = updatedNode;
        return true;
      }
      if (nodes[i].children && nodes[i].children!.length > 0) {
        if (this.updateNodeInTree(nodes[i].children!, updatedNode)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Convierte el árbol a lista plana de MenuItem
   */
  flattenTree(nodes: MenuTreeNode[]): MenuItem[] {
    const result: MenuItem[] = [];

    const flatten = (items: MenuTreeNode[]) => {
      items.forEach((item) => {
        const menuItem = new MenuItem();
        menuItem.id = item.id;
        menuItem.icon = item.icon;
        menuItem.icon_fntaws = item.icon_fntaws;
        menuItem.text = item.text;
        menuItem.color = item.color;
        menuItem.link = item.link;
        menuItem.permission = item.permission;
        menuItem.id_padre = item.id_padre;
        menuItem.url_fija = item.url_fija;
        menuItem.orden = item.orden;

        result.push(menuItem);

        if (item.children && item.children.length > 0) {
          flatten(item.children);
        }
      });
    };

    flatten(nodes);
    return result;
  }

  /**
   * Guarda el orden actualizado
   */
  async guardarOrden() {
    this.guardando = true;
    try {
      // Recalcular todos los órdenes antes de guardar
      this.recalcularOrdenes(this.menuTree, null);

      // Convertir árbol a lista plana
      const menuItems = this.flattenTree(this.menuTree);

      console.log("Guardando orden del menú:", menuItems);

      // Guardar cada item
      for (const item of menuItems) {
        await menu_optionModule.modificarmenu_option(item);
      }

      console.log("Orden del menú guardado correctamente");
      await this.cargarMenu(); // Recargar para refrescar
    } catch (error) {
      console.error("Error al guardar el orden del menú:", error);
    } finally {
      this.guardando = false;
    }
  }
}
